import ajax from "../utils/request";
const userConfigurationApi = {
  /********************************用户聚合管理*********************************** */
  // 请求聚合列表
  getUserAssembleList(params) {
    return ajax({
      url: "/assemble/list",
      type: "get",
      params: params,
    });
  },
  // 添加聚合
  addUserAssemble(params) {
    return ajax({
      url: "/assemble/create",
      type: "post",
      params: params,
    });
  },
  // 删除聚合
  deleteUserAssemble(params) {
    return ajax({
      url: "/assemble/del",
      type: "delete",
      params: params,
    });
  },
  /********************************用户喜好项管理*********************************** */
  // 请求用户喜好项
  getUserFavorOptionList(params) {
    return ajax({
      url: "/favorOption/list",
      type: "get",
      params: params,
    });
  },
  // 添加用户喜好项
  addUserFavorOption(params) {
    return ajax({
      url: "/favorOption/create",
      type: "post",
      params: params,
    });
  },
  // 修改用户喜好项
  updateUserFavorOption(params) {
    return ajax({
      url: "/favorOption/update",
      type: "post",
      params: params,
    });
  },
  // 删除用户喜好项
  deleteUserFavorOption(params) {
    return ajax({
      url: "/favorOption/del",
      type: "delete",
      params: params,
    });
  },
};

export default userConfigurationApi;
